import { User } from '../models/User'
import { atom, selector, useRecoilValue, useResetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import apiService from '../services/api'
import { UserContext } from '../models/UserContext'

const initialUserContext: UserContext = {
    aree: [],
    authorizationId: 0,
    authorizationToken: '',
    codice: '',
    descriCodice: '',
    id: 0,
    livello: '',
    name: '',
    province: [],
    provincia: '',
    ufficio: '',
    ufficioCorrente: '',
    xSixContext: '',
    descrizioneProvincia: '',
    consentiMarketing: false,
    banner: true,
    notizia: true,
    notifica: '',
}

export const anonymousUser: User = {
    isAuthenticated: false,
    name: 'anonymous',
    role: 'guest',
    claims: [],
    nameClaimType: 'name',
    roleClaimType: 'role',
    xSixContext: '',
    mail: 'anonymous@somemail.net',
    context: initialUserContext,
}

export const userState = atom({
    key: 'userState',
    default: apiService.getUser()
})


export const userContext = selector({
    key: 'userContext',
    get: ({ get }) => {
        const user = get(userState)
        return user?.context ?? initialUserContext
    }
})

export const useSignout = () => {
    const navigate = useNavigate()
    const resetUser = useResetRecoilState(userState)
    const signout = (to?: string) => {
        resetUser()
        navigate(to ?? '/')
    }
    return signout
}

export type AvatarInfoType = {
    name: string,
    image?: string,
    initials: string,
}

const extractInitials = (email: string) => {
    const temp = email.split('.')
    if (temp.length > 1) {
        return (temp[0].substring(0, 1) + temp[1].substring(0, 1)).toUpperCase()
    } else {
        return email.substring(0, 2).toUpperCase()
    }
}

const avatarSelector = selector({
    key: 'avatarSelector',
    get: ({ get }) => {
        const user = get(userState) ?? anonymousUser

        const rv: AvatarInfoType = { name: user.name, initials: extractInitials(user.mail ?? user.name) }
        if (user.isAuthenticated) {
            if (user.name === 'gioturrini@tin.it') rv.image = "avatars/d22102db-2ffc-4596-8cfe-ff79bed51e05.jpg"
        } else {
            rv.initials = 'A'
        }
        return rv
    }
})

export const useAvatar = (image?: string) => {
    const avatar = useRecoilValue(avatarSelector)
    return { ...avatar, image }
}

export const isAdminState = selector({
    key: 'isAdminState',
    get: ({ get }) => {
        const user = get(userState)
        const role = user?.role ?? 'guest'
        return role === 'admin'
    }
})
